module.exports = __webpack_public_path__ + "img/TheGreatChasm-800-450.847fd7d9.jpg";